import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  // Start with 2 hours, 47 minutes, 0 seconds
  const [timeLeft, setTimeLeft] = useState(2 * 3600 + 47 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-[#DC2626] text-white py-3 px-4 shadow-md" data-id="element-127">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-2 sm:gap-4" data-id="element-128">
        <p className="text-sm sm:text-base font-bold uppercase tracking-wide" data-id="element-129">
          ¡ATENCIÓN! Oferta de lanzamiento para la comunidad hispana: 92% de
          descuento finaliza en
        </p>
        <div className="flex items-center bg-black/20 px-3 py-1 rounded-md" data-id="element-130">
          <Clock className="w-4 h-4 mr-2" data-id="element-131" />
          <motion.span className="font-mono font-bold text-lg" animate={{
          opacity: [1, 0.7, 1]
        }} transition={{
          repeat: Infinity,
          duration: 1
        }} data-id="element-132">
            {formatTime(timeLeft)}
          </motion.span>
        </div>
      </div>
    </div>;
}